module.exports = __webpack_public_path__ + "img/regiter-icon05.42777636.png";